<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex lg8 md8 sm12 xs12>
            <v-layout row wrap>
              <v-flex xs12 v-if="course.short_description">
                <v-card>
                  <v-card-text class="pa-4 enr-course-description">
                    <div v-if="course.short_description && course.short_description.length > 500">
                      <div v-if="!readMoreActivatedShort">
                        <span style="white-space: break-spaces">{{ course.short_description.slice(0, 500) + "... " }}</span>
                      </div>
                      <a class="" v-if="!readMoreActivatedShort" @click="readMoreActivatedShort = !readMoreActivatedShort" href="#"
                        >{{ $t("global.show_more") }}...</a
                      >

                      <div v-if="readMoreActivatedShort">
                        <span style="white-space: break-spaces">{{ course.short_description }}</span>
                      </div>
                      <a class="" v-if="readMoreActivatedShort" @click="readMoreActivatedShort = !readMoreActivatedShort" href="#"
                        >{{ $t("global.show_less") }}...</a
                      >
                    </div>
                    <div v-if="course.short_description && course.short_description.length <= 500">
                      <div>
                        <span style="white-space: break-spaces">{{ course.short_description }}</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 v-if="course.description">
                <v-card>
                  <v-card-text class="pa-4 mt-2 mb-2 enr-course-description">
                    <div v-if="course.description && course.description.length > 500">
                      <span style="white-space: break-spaces" v-if="!readMoreActivated"
                        >{{ course.description.slice(0, 500) + "... " }}
                      </span>
                      <a class="" v-if="!readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                        >{{ $t("global.show_more") }}...</a
                      >

                      <span style="white-space: break-spaces" v-if="readMoreActivated">{{ course.description }} </span>
                      <a class="" v-if="readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                        >{{ $t("global.show_less") }}...</a
                      >
                    </div>
                    <div v-if="course.description && course.description.length <= 500">
                      <span style="white-space: break-spaces">{{ course.description }} </span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <v-expansion-panels v-model="clpsEnrDetailExpand" class="cstm-filter mt-4 elevation-0">
              <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                  <span>
                    <v-icon dark>{{ clpsEnrDetailIcon }}</v-icon>
                    <span>{{ " " + $t("fe.enrolment.o_name") + " " + $t("fe.enrolment.details") }}</span>
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="elevation-1">
                  <v-layout row wrap>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field
                        v-model="organisation.name"
                        :label="$t('fe.enrolment.o_name')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field
                        v-model="organisation.vat"
                        :label="$t('fe.enrolment.o_vat')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12></v-flex>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field
                        v-model="organisation.req_first_name"
                        :label="$t('fe.enrolment.o_first_name')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field
                        v-model="organisation.req_last_name"
                        :label="$t('fe.enrolment.o_last_name')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field
                        v-model="organisation.req_email"
                        :label="$t('fe.enrolment.o_email')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-subheader class="pl-0"
                    ><b>{{ $t("fe.enrolment.visiting_address") }}</b></v-subheader
                  >

                  <v-layout wrap>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field
                        v-model="organisation.visiting_street"
                        :label="$t('fe.enrolment.o_address_street')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm4 xs12>
                      <v-text-field
                        v-model="organisation.visiting_zip"
                        :label="$t('fe.enrolment.o_address_zip')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm8 xs12>
                      <v-text-field
                        v-model="organisation.visiting_city"
                        :label="$t('fe.enrolment.o_address_city')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12 xs12>
                      <v-text-field
                        :value="organisation.visiting_country ? $dd_countries(organisation.visiting_country) : null"
                        :label="$t('fe.enrolment.o_address_country')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-subheader class="pl-0"
                    ><b>{{ $t("fe.enrolment.invoice_address") }}</b></v-subheader
                  >

                  <v-layout wrap>
                    <v-flex lg4 md4 sm6 xs12>
                      <v-text-field
                        v-model="organisation.invoice_street"
                        :label="$t('fe.enrolment.o_address_street')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm4 xs12>
                      <v-text-field
                        v-model="organisation.invoice_zip"
                        :label="$t('fe.enrolment.o_address_zip')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg4 md4 sm8 xs12>
                      <v-text-field
                        v-model="organisation.invoice_city"
                        :label="$t('fe.enrolment.o_address_city')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12 xs12>
                      <v-text-field
                        :value="organisation.invoice_country ? $dd_countries(organisation.invoice_country) : null"
                        :label="$t('fe.enrolment.o_address_country')"
                        readonly
                        autocomplete="new-password"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels v-model="clpsEnrParExpand" class="cstm-filter mt-4 elevation-0" ref="attendees_expansion_panels">
              <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                  <span>
                    <v-icon dark>{{ clpsEnrParIcon }}</v-icon>
                    {{ $t("fe.enrolment.participants") }}
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="elevation-1">
                  <v-data-table
                    class="enr_table"
                    :headers="enr_headers"
                    :items="enrolments"
                    item-key="id"
                    :expanded.sync="expanded"
                    show-expand
                    :hide-default-footer="true"
                    disable-pagination
                    :must-sort="true"
                  >
                    <template v-slot:item.number="{ index }">
                      <v-chip small dark color="primary">{{ index + 1 }}</v-chip>
                    </template>
                    <template v-slot:item.date_of_birth="{ item }">
                      {{ item.date_of_birth ? $dateFormatGetter(item.date_of_birth) : null }}
                    </template>
                    <template v-slot:expanded-item="{ item }">
                      <td colspan="7" style="background: #fff">
                        <v-container grid-list-md class="pa-2 my-3" elevation-2>
                          <v-layout wrap>
                            <v-flex sm12 md6 lg6>
                              <p class="font-weight-black sidebar-price-title mb-2">
                                {{ $t("fe.enrolment.include") }}
                              </p>

                              <v-simple-table dense>
                                <template v-for="mt in additionals_data[item.id].filter((i) => i.is_included)">
                                  <tr :key="mt.mt_id + '-' + $uuid()" class="grey-tr">
                                    <td scope="row" colspan="2" class="font-weight-black text-gray pl-1">
                                      {{ mt.name }}
                                    </td>
                                  </tr>
                                  <tr :key="mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.mo_id">
                                    <td scope="row" class="pl-3">
                                      {{ mt.mo_name }}
                                      {{ mt.mo_hours ? " (" + mt.mo_hours + " " + $t("moduleoptions.hours") + ")" : "" }}
                                    </td>
                                    <td scope="row" class="text-end" width="20%">
                                      {{ mt.mo_price ? mt.mo_price + " " + CURRENCY : "" }}
                                    </td>
                                  </tr>
                                  <tr :key="mt.id + '-' + mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.moct && mt.moct.length > 0">
                                    <td colspan="2" class="pr-0" style="background: white">
                                      <v-simple-table dense class="pl-5">
                                        <tr v-for="moct in mt.moct" :key="moct.id + '-' + $uuid()">
                                          <td scope="row">{{ moct.name }}</td>
                                          <td scope="row" class="text-end" width="20%">
                                            {{ moct.price ? moct.price + " " + CURRENCY : "" }}
                                          </td>
                                        </tr>
                                      </v-simple-table>
                                    </td>
                                  </tr>
                                </template>
                              </v-simple-table>

                              <v-divider class="my-3"></v-divider>

                              <p class="font-weight-black mt-3 sidebar-price-title mb-2">
                                {{ $t("fe.enrolment.additionals") }}
                              </p>

                              <v-simple-table dense>
                                <template v-for="mt in additionals_data[item.id].filter((i) => !i.is_included)">
                                  <tr :key="mt.mt_id + '-' + $uuid()" class="grey-tr">
                                    <td scope="row" colspan="2" class="font-weight-black text-gray pl-1">
                                      {{ mt.name }}
                                    </td>
                                  </tr>
                                  <tr :key="mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.mo_id">
                                    <td scope="row" class="pl-3">
                                      {{ mt.mo_name }}
                                      {{ mt.mo_hours ? " (" + mt.mo_hours + " " + $t("moduleoptions.hours") + ")" : "" }}
                                    </td>
                                    <td scope="row" class="text-end" width="20%">
                                      {{ mt.mo_price ? mt.mo_price + " " + CURRENCY : "" }}
                                    </td>
                                  </tr>
                                  <tr :key="mt.id + '-' + mt.mo_id + '-' + $uuid()" class="white-tr" v-if="mt.moct && mt.moct.length > 0">
                                    <td colspan="2" class="pr-0" style="background: white">
                                      <v-simple-table dense class="pl-5">
                                        <tr v-for="moct in mt.moct" :key="moct.id + '-' + $uuid()">
                                          <td scope="row">{{ moct.name }}</td>
                                          <td scope="row" class="text-end" width="20%">
                                            {{ moct.price ? moct.price + " " + CURRENCY : "" }}
                                          </td>
                                        </tr>
                                      </v-simple-table>
                                    </td>
                                  </tr>
                                </template>
                              </v-simple-table>
                            </v-flex>
                            <v-flex sm12 md6 lg6>
                              <v-simple-table dense class="enr_details_table">
                                <tr>
                                  <td scope="row">
                                    <p class="font-weight-black price">
                                      {{ $t("fe.enrolment.price") }}
                                    </p>
                                  </td>
                                  <td scope="row" class="text-end price" width="20%">
                                    <span>{{ price[item.id] + " " + CURRENCY }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">
                                    <p class="font-weight-black price">
                                      {{ $t("fe.enrolment.price_additional") }}
                                    </p>
                                  </td>
                                  <td scope="row" class="text-end price" width="20%">
                                    <span>{{ price_additional[item.id] + " " + CURRENCY }}</span>
                                  </td>
                                </tr>
                                <tr>
                                  <td scope="row">
                                    <p class="font-weight-black price">
                                      {{ $t("fe.enrolment.price_total") }}
                                    </p>
                                  </td>
                                  <td scope="row" class="text-end price" width="20%">
                                    <span>{{ price_total[item.id] + " " + CURRENCY }}</span>
                                  </td>
                                </tr>
                              </v-simple-table>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </td>
                    </template>
                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12 class="px-5">
            <p class="font-weight-black sidebar-price-title mb-2">
              {{ $t("fe.enrolment.include") }}
            </p>

            <!-- INCLUDES -->
            <div
              v-for="mt in _.filter(summary_additionals_data, (item) => {
                return item.is_included
              })"
              :key="mt.id"
            >
              <p class="font-weight-black mb-1">{{ mt.name }}</p>

              <v-simple-table dense>
                <template v-for="mo in mt.mo">
                  <tr :key="'mo-' + mo.id">
                    <td scope="row" width="75%" class="pl-3">
                      {{ mo.name + (mo.hours > 0 ? " (" + mo.hours + " " + $t("moduleoptions.hours") + ")" : "") }}
                    </td>
                    <td scope="row">
                      <span class="font-weight-black mr-5"> {{ mo.count }} x </span>
                    </td>
                    <td scope="row" class="text-end va-text-top price" width="15%">
                      <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                    </td>
                  </tr>
                  <tr v-for="moct in mo.moct" :key="moct.id">
                    <td scope="row" width="75%" class="pl-6">
                      {{ moct.name }}
                    </td>
                    <td scope="row">
                      <span class="font-weight-black mr-5"> {{ moct.count }} x </span>
                    </td>
                    <td scope="row" class="text-end va-text-top price" width="15%">
                      <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                    </td>
                  </tr>
                </template>
              </v-simple-table>
            </div>

            <v-divider class="my-3"></v-divider>

            <p class="font-weight-black mt-3 sidebar-price-title mb-2">
              {{ $t("fe.enrolment.additionals") }}
            </p>

            <!-- ADDITIONAL -->
            <div
              v-for="mt in _.filter(summary_additionals_data, (item) => {
                return !item.is_included
              })"
              :key="mt.id"
            >
              <p class="font-weight-black mb-1">{{ mt.name }}</p>

              <v-simple-table dense>
                <template v-for="mo in mt.mo">
                  <tr :key="'mo-' + mo.id">
                    <td scope="row" width="75%" class="pl-3">
                      {{ mo.name + (mo.hours > 0 ? " (" + mo.hours + " " + $t("moduleoptions.hours") + ")" : "") }}
                    </td>
                    <td scope="row">
                      <span class="font-weight-black mr-5"> {{ mo.count }} x </span>
                    </td>
                    <td scope="row" class="text-end va-text-top price" width="15%">
                      <span v-if="mo.price">{{ mo.price + " " + CURRENCY }}</span>
                    </td>
                  </tr>
                  <tr v-for="moct in mo.moct" :key="moct.id">
                    <td scope="row" width="75%" class="pl-6">
                      {{ moct.name }}
                    </td>
                    <td scope="row">
                      <span class="font-weight-black mr-5"> {{ moct.count }} x </span>
                    </td>
                    <td scope="row" class="text-end va-text-top price" width="15%">
                      <span v-if="moct.price">{{ moct.price + " " + CURRENCY }}</span>
                    </td>
                  </tr>
                </template>
              </v-simple-table>
            </div>

            <v-divider class="mb-3"></v-divider>

            <!-- TOTAL -->
            <v-simple-table dense class="mt-3">
              <tr>
                <td scope="row" width="75%">
                  <p class="font-weight-black price">
                    {{ $t("fe.enrolment.price") }}
                  </p>
                </td>
                <td scope="row">
                  <span v-if="enrolments.length > 1" class="font-weight-black mr-5">{{ enrolments.length }} x</span>
                </td>
                <td scope="row" class="text-end price" width="15%">
                  <span>{{ course.price + " " + CURRENCY }}</span>
                </td>
              </tr>
              <tr>
                <td scope="row" colspan="2">
                  <p class="font-weight-black price">
                    {{ $t("fe.enrolment.price_additional") }}
                  </p>
                </td>
                <td scope="row" class="text-end price">
                  <span>{{ all_price_additional + " " + CURRENCY }}</span>
                </td>
              </tr>
              <tr>
                <td scope="row" colspan="2">
                  <p class="font-weight-black price">{{ $t("fe.enrolment.price_total") }}</p>
                </td>
                <td scope="row" class="text-end price">
                  <span>{{ all_price_total + " " + CURRENCY }}</span>
                </td>
              </tr>
            </v-simple-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "EnrolmentRequestorView",

  props: ["id", "locale", "group_id"],

  data() {
    return {
      page_title: "",

      course: {
        price: 0
      },
      original_course_name: "",
      enrolments: [],
      organisation: {},

      additionals_data: {},
      summary_additionals_data: {},

      price: {},
      price_additional: {},
      price_total: {},

      all_price: 0,
      all_price_additional: 0,
      all_price_total: 0,

      clpsEnrDetailExpand: 0,
      clpsEnrDetailIcon: "mdi-expand-all-outline",
      clpsEnrParExpand: 0,
      clpsEnrParIcon: "mdi-expand-all-outline",

      expanded: [],

      readMoreActivated: false,
      readMoreActivatedShort: false
    }
  },

  computed: {
    enr_headers() {
      return [
        { text: "", value: "data-table-expand", width: "10px", sortable: false },
        { text: "", value: "number", width: "10px", sortable: false },
        { text: this.$t("fe.enrolment.p_first_name"), value: "first_name", sortable: false },
        { text: this.$t("fe.enrolment.p_last_name"), value: "last_name", sortable: false },
        { text: this.$t("fe.enrolment.p_email"), value: "email", sortable: false },
        { text: this.$t("fe.enrolment.p_mobile"), value: "mobile", sortable: false },
        { text: this.$t("fe.enrolment.p_date_of_birth"), value: "date_of_birth", sortable: false }
      ]
    }
  },

  watch: {
    clpsEnrDetailExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrDetailIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsEnrParExpand: {
      handler(newVal, oldVal) {
        this.clpsEnrParIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  created() {
    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    this.page_title = this.$t("fe.enrolment.title")

    axios
      .get(this.API_URL + "open/enrolment/requestor/" + this.group_id)
      .then((res) => {
        this.enrolments = res.data.data

        this.additionals_data = {}
        this.summary_additionals_data = {}

        this.price = {}
        this.price_additional = {}
        this.price_total = {}

        this.all_price = 0
        this.all_price_additional = 0
        this.all_price_total = 0

        if (this.enrolments.length > 0) {
          let json = JSON.parse(this.enrolments[0].original_course_data)
          if (json && json.course) {
            this.course = json.course
            this.original_course_name = this.course.name

            let enr_moduleoptions = {}
            let enr_moduleoptions_coursetypes = {}
            this.enrolments.forEach((enrolment) => {
              let additionals = enrolment.additionals

              enr_moduleoptions[enrolment.id] = []
              enr_moduleoptions_coursetypes[enrolment.id] = []

              this.additionals_data[enrolment.id] = []
              this.price[enrolment.id] = this.course.price
              this.price_additional[enrolment.id] = 0
              this.price_total[enrolment.id] = 0

              if (additionals) {
                // per student
                additionals.forEach((item) => {
                  let mt = this.course.moduletemplates.find((i) => i.id == item.moduletemplate_id)
                  if (mt && typeof mt.moduleoptions !== "undefined") {
                    let mo = mt.moduleoptions.find((i) => i.id == item.moduleoption_id)

                    if (mt && mo) {
                      // module template / option
                      if (!this.additionals_data[enrolment.id].find((i) => i.mt_id == item.moduletemplate_id)) {
                        this.additionals_data[enrolment.id].push({
                          mt_id: mt.id,
                          mo_id: mo ? mo.id : null,
                          name: mt.name,
                          price: mt.price,
                          hours: mt.req_hours,
                          is_included: mt.is_included,
                          mo_name: mo ? mo.name : null,
                          mo_price: mo ? mo.price : null,
                          mo_hours: mo ? mo.hours : null,
                          moct: []
                        })

                        if (mo && mo.price) {
                          this.price_additional[enrolment.id] += mo.price
                        }
                      }

                      // moduleoption course type
                      if (item.moduleoptioncoursetype_id) {
                        let moct = mo.coursetypes.find((i) => i.id == item.moduleoptioncoursetype_id)
                        if (moct) {
                          let data = this.additionals_data[enrolment.id].find(
                            (i) => i.mt_id == item.moduletemplate_id && i.mo_id == item.moduleoption_id
                          )
                          if (data) {
                            data["moct"].push({
                              name: moct.name,
                              price: moct.price
                            })

                            if (moct.price) {
                              this.price_additional[enrolment.id] += moct.price
                            }
                          }
                        }
                      }
                    }
                  }
                })

                // summary data
                additionals.forEach((item) => {
                  let mt = this.course.moduletemplates.find((i) => i.id == item.moduletemplate_id)
                  if (mt && typeof mt.moduleoptions !== "undefined") {
                    let mo = mt.moduleoptions.find((i) => i.id == item.moduleoption_id)

                    // module template
                    if (mo && !this.summary_additionals_data.hasOwnProperty(item.moduletemplate_id)) {
                      this.summary_additionals_data[item.moduletemplate_id] = {}
                      this.summary_additionals_data[item.moduletemplate_id] = {
                        id: mt.id,
                        name: mt.name,
                        price: mt.price,
                        hours: mt.req_hours,
                        is_included: mt.is_included,
                        mo: {}
                      }
                    }

                    // module option
                    if (mo && item.moduleoption_id) {
                      if (!this.summary_additionals_data[item.moduletemplate_id]["mo"].hasOwnProperty(item.moduleoption_id)) {
                        this.summary_additionals_data[item.moduletemplate_id]["mo"][mo.id] = {
                          id: mo.id,
                          name: mo.name,
                          price: mo.price,
                          count: 0,
                          moct: {}
                        }
                      }

                      // count module options
                      if (!enr_moduleoptions[enrolment.id].find((i) => i == mo.id)) {
                        enr_moduleoptions[enrolment.id].push(mo.id)
                        this.summary_additionals_data[item.moduletemplate_id]["mo"][mo.id].count++
                      }
                    }

                    // module option course type
                    if (mo && item.moduleoptioncoursetype_id) {
                      let moct = mo.coursetypes.find((i) => i.id == item.moduleoptioncoursetype_id)
                      if (moct) {
                        if (
                          !this.summary_additionals_data[item.moduletemplate_id]["mo"][mo.id]["moct"].hasOwnProperty(
                            item.moduleoptioncoursetype_id
                          )
                        ) {
                          this.summary_additionals_data[item.moduletemplate_id]["mo"][mo.id]["moct"][moct.id] = {
                            id: moct.id,
                            name: moct.name,
                            price: moct.price,
                            count: 0
                          }
                        }

                        // count module options
                        if (!enr_moduleoptions_coursetypes[enrolment.id].find((i) => i == moct.id)) {
                          enr_moduleoptions_coursetypes[enrolment.id].push(moct.id)
                          this.summary_additionals_data[item.moduletemplate_id]["mo"][mo.id]["moct"][moct.id].count++
                        }
                      }
                    }
                  }
                })
              }

              // compute price, additional, and total
              this.price_total[enrolment.id] = this.price[enrolment.id] + this.price_additional[enrolment.id]

              this.all_price += this.price[enrolment.id]
              this.all_price_additional += this.price_additional[enrolment.id]
              this.all_price_total += this.price_total[enrolment.id]
            })

            this.page_title =
              this.$t("fe.enrolment.enrolment_to") +
              " " +
              this.course.name +
              ", " +
              this.$dateFormatGetter(this.course.start_date) +
              " " +
              this.$timeFormatGetter(this.course.start_time) +
              " - " +
              this.$dateFormatGetter(this.course.end_date) +
              " " +
              this.$timeFormatGetter(this.course.end_time)
          }

          this.organisation = this.enrolments[0].organisation
        }
      })
      .catch((err) => console.log(err))
  }
}
</script>

<style scoped>
.text-gray {
  color: rgba(0, 0, 0, 0.54) !important;
}
.white-tr {
  background: none !important;
}
.grey-tr {
  background: rgba(0, 0, 0, 0.12) !important;
}
.white-tr td {
  border-bottom: none !important;
}
</style>
